import { useCurrentTemplate } from "./useCurrentTemplate"

export const useStandardText = () => {
	const currentTemplate = useCurrentTemplate()
	return {
		standardText: currentTemplate?.standardText,
	}
}
